export default __webpack_public_path__ + "static/media/complementary--bike-route--g3.1a874469.png";